<template>
  <div class="hub-header" >
    <!-- <div class="hub-header__head" :class="{ 'hub-header__head--no-border': hasNoBorder }"> -->
    <div class="hub-header__head" >
    <!-- <div :class="headClasses"> -->

      <!-- Back -->
      <div class="hub-header__back" v-if="backBtn">
        <BaseButton icon="chevron-left" @click.native="handleBack" clear />
      </div>

      <!-- Title -->
      <div class="hub-header__title">
        <BaseTitle :tag="titleTag" :class="customTitleClass" :icon="category" v-if="category">{{ title }} </BaseTitle>
        <BaseTitle :tag="titleTag" :class="customTitleClass" v-else>
          {{ title }}
          <ElementBadge
            :color="colorGuid"/>
          <ElementTag :text="showTag" color="yellow" v-if="showTag" />
        </BaseTitle>
      </div>

      <!-- Actions -->
      <div class="hub-header__actions" v-if="email">
        <BaseButton icon="mail" :url="mailtoUrl" clear />
        <BaseButton icon="print" @click.native="handlePrint" clear />
      </div>

      <!-- Others (example: select) -->
      <slot></slot>

    </div>

    <!-- Description -->
    <div class="hub-header__body" v-if="description">
      <p v-html="description" />
    </div>

  </div>
</template>

<script>
import BaseTitle from '@base/BaseTitle'
import BaseButton from '@base/BaseButton'
import ElementBadge from '@elements/ElementBadge'
import ElementTag from '@elements/ElementTag'

export default {
  name: 'HubHeader',
  props: {
    showTag: {
      type: [String, Number],
      required: false
    },
    category: {
      type: String,
      required: false,
      default: ''
    },
    titleTag: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    email: {
      type: String,
      required: false,
      default: ''
    },
    backBtn: {
      type: Boolean,
      required: false
    },
    colorGuid: {
      type: String,
      required: false,
      default: ''
    }
  },
  components: {
    BaseTitle,
    BaseButton,
    ElementBadge,
    ElementTag
  },
  computed: {
    hasNoBorder () {
      return !this.description && !['CropLife Structure', 'My Holidays', 'Groups & Teams'].includes(this.$route.name)
    },
    headClasses () {
      return [
        'hub-header__head',
        { 'hub-header__head--no-border': !this.description }
      ]
    },
    customTitleClass () {
      return [
        this.category ? `title--${this.category}` : ''
      ]
    },
    mailtoUrl () {
      return (this.email) ? `mailto:${this.email}?subject=Contact us` : ''
    }
  },
  methods: {
    handlePrint () {
      window.print()
    },
    handleBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
.hub-header{

  // Head

  &__head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: layout("spacing")/2;
    border-bottom: 1px solid tint(black, 90%);

    &--no-border{
      .view &{
        border-bottom: 0;
        padding-bottom: 0;
      }
    }
  }

  // Title

  &__title{
    margin-right: layout("spacing");
    flex: 1 1 auto;

    h2{
      @media print {
        font-size: 16pt;
      }
      margin-bottom: 0;
      font-size: 2.8rem;
      font-weight: font-weights("normal");
    }
  }

  // Back

  &__back{
    @media print {
      display: none !important;
    }
    .button{
      padding: 0;
    }
    .icon{
      margin-right: 1rem;
      width: 4rem;
      height: 4rem;
      text-align: center;
      background-color: colors('modules');
      border-top-left-radius: 50%;
      border-bottom-right-radius: 50%;
      color: white;
      font-size: 1.8rem;
    }
  }

  // Actions

  &__actions{
    @media print {
      display: none !important;
    }
    flex: 0 0 auto;

    .button{
      @include text-color(colors("primary"));
      padding: 0;
      &:not(:last-of-type){
        margin-right: layout("spacing")/2;
      }
    }

    .icon-mail{
      font-size: 1.5rem;
    }

    .icon-print{
      font-size: 2rem;
    }
  }

  // Body

  &__body{
    @include media("small-medium"){
      font-size: 1.6rem;
    }
    @include media("large"){
      font-size: 1.4rem;
    }
    padding-top: layout("spacing")/2;
    padding-bottom: layout("spacing")/2;
    // padding-bottom: layout("spacing");
    p:last-of-type{
      margin: 0;
    }
  }
}
</style>
